import get from 'lodash.get';

export const getLicenseProductLabel = (license) => {
  const nestedProductName =
    get(license, 'product.product_name') ||
    get(license, 'product.name') ||
    get(license, 'product_name');

  if (nestedProductName) {
    return nestedProductName;
  }

  const productValue = get(license, 'product');
  if (typeof productValue === 'string') {
    return productValue;
  }

  return get(license, 'product_code', '');
};

export const mapLicenses = (data) => {
  const licenses = [];

  if (Array.isArray(data)) {
    data.forEach((d) => {
      const licensesList = get(d, 'licenses', []);

      licensesList.forEach((l) => {
        const license = {
          ...l,
          product: getLicenseProductLabel(l),
        };
        licenses.push(license);
      });
    });
  }

  return licenses;
};
